/**
 * Design Tokens for Ctl Management Theme
 * 
 * Extends the base landing-page theme tokens with Ctl Management branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-landing-page/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Ctl Management brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Keep CTA / on-primary label text white (privacy banner + primary buttons)
    textOnPrimary: '#ffffff',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    // Ctl Management typography - customize these
    // heading: '"Your Heading Font", serif',
    // body: '"Your Body Font", sans-serif',
  },
};

export default tokens;
